import { Stack, Text, AppShell, ScrollArea } from "@mantine/core";
import {
  IconHome,
  IconClock,
  IconBrain,
  IconAdjustments,
  IconChartBar,
  IconArchive,
} from "@tabler/icons-react";

import SidebarNavLink from "./SidebarNavLink";

export default function AdminSidebar() {
  return (
    <AppShell.Section grow component={ScrollArea}>
      <Stack gap={0}>
        {/* Event Management */}
        <Text
          size="xs"
          fw={600}
          c="dimmed"
          mb="xs"
          mt="sm"
          tt="uppercase"
          px="md"
        >
          Event Management
        </Text>
        <SidebarNavLink
          href="/"
          label="Dashboard"
          icon={<IconHome size={20} />}
        />

        {/* Queue & Processing */}
        <Text
          size="xs"
          fw={600}
          c="dimmed"
          mb="xs"
          mt="lg"
          tt="uppercase"
          px="md"
        >
          Queue & Processing
        </Text>
        <SidebarNavLink
          href="/queue-jobs"
          label="Queue Jobs"
          icon={<IconClock size={20} />}
        />
        <SidebarNavLink
          href="/data-archives"
          label="Data Archives"
          icon={<IconArchive size={20} />}
        />

        {/* Reports */}
        <Text
          size="xs"
          fw={600}
          c="dimmed"
          mb="xs"
          mt="lg"
          tt="uppercase"
          px="md"
        >
          Reports
        </Text>
        <SidebarNavLink
          href="/stats"
          label="Stats Reports"
          icon={<IconChartBar size={20} />}
        />

        {/* System & Testing */}
        <Text
          size="xs"
          fw={600}
          c="dimmed"
          mb="xs"
          mt="lg"
          tt="uppercase"
          px="md"
        >
          System & Testing
        </Text>
        <SidebarNavLink
          href="/test-gemini"
          label="Test Gemini"
          icon={<IconBrain size={20} />}
        />
        <SidebarNavLink
          href="/configs"
          label="Configs"
          icon={<IconAdjustments size={20} />}
        />
      </Stack>
    </AppShell.Section>
  );
}
